import * as React from 'react';
import clsx from 'clsx';

import { MountPoints } from '@tock/shared/constants/portalLocationConstants';
import ModalWrapper from '@tock/shared/components/ModalWrapper';

type ModalVariant = 'DEFAULT' | 'FULLSCREEN' | 'FULL_HEIGHT' | 'FULLSCREEN_NO_BORDER';

export interface Props {
  children?: React.ReactNode;
  className?: string;
  isOpen?: boolean;
  isMinimized?: boolean;
  modifiers?: string[];
  mountLocation?: MountPoints;
  onClose(): void;
  onMaximize?(event: React.MouseEvent<HTMLElement>): void;
  variant?: ModalVariant;
  'data-testid'?: string;
}

/**
 * @deprecated Use ui/Dialog instead
 */
function ComposableModal({
  children,
  className,
  isOpen,
  isMinimized = false,
  modifiers,
  mountLocation,
  onClose,
  onMaximize,
  variant,
  'data-testid': dataTestId,
}: Props) {
  return (
    <ModalWrapper
      className={clsx(
        className,
        {
          'ComposableModal--fullscreen': variant === 'FULLSCREEN',
          'ComposableModal--fullHeight': variant === 'FULL_HEIGHT',
          'ComposableModal--fullscreen-no-border': variant === 'FULLSCREEN_NO_BORDER',
        },
        'ComposableModal--minimizeable',
        {
          'ComposableModal--minimizeable--is-minimized': isMinimized,
        }
      )}
      isOpen={isOpen}
      isMinimized={isMinimized}
      mountLocation={mountLocation}
      modifiers={modifiers}
      onClose={onClose}
      onMaximize={onMaximize}
      data-testid={dataTestId}
    >
      {children}
    </ModalWrapper>
  );
}

export default ComposableModal;
